/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Director_NameInputs */

const en_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (each individually authorized)`)
};

const de_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (jeweils einzelvertretungsberechtigt)`)
};

const fr_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (chacun individuellement autorisé)`)
};

const es_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (cada uno autorizado individualmente)`)
};

const it_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (ciascuno autorizzato individualmente)`)
};

const nl_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (elk afzonderlijk bevoegd)`)
};

const pl_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (każdy upoważniony samodzielnie)`)
};

const fi_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (kumpikin erikseen valtuutettu)`)
};

const da_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (hver individuelt bemyndiget)`)
};

const sv_impressum_director_name = /** @type {(inputs: Impressum_Director_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaisakhan Arackal Sanu & Chris Zanfir (var och en enskilt behörig)`)
};

/**
* | output |
* | --- |
* | "Vaisakhan Arackal Sanu & Chris Zanfir (each individually authorized)" |
*
* @param {Impressum_Director_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_director_name = /** @type {((inputs?: Impressum_Director_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Director_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_director_name(inputs)
	if (locale === "fr") return fr_impressum_director_name(inputs)
	if (locale === "es") return es_impressum_director_name(inputs)
	if (locale === "it") return it_impressum_director_name(inputs)
	if (locale === "nl") return nl_impressum_director_name(inputs)
	if (locale === "pl") return pl_impressum_director_name(inputs)
	if (locale === "fi") return fi_impressum_director_name(inputs)
	if (locale === "da") return da_impressum_director_name(inputs)
	if (locale === "sv") return sv_impressum_director_name(inputs)
	return en_impressum_director_name(inputs)
});